import MultipleChoiceQuestionTemplate from '~/pages/anatomyV2/libs/components/MultipleChoiceQuestionTemplate'
import { MULTIPLE_CHOICE_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/multipleChoiceCorrectAnswers'
import {
  earPNG,
  earWEBP,
  eyePNG,
  eyeWEBP,
  nosePNG,
  noseWEBP,
  pinkyToePNG,
  pinkyToeWEBP,
} from '~/pages/anatomyV2/smallestBone/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 3

const OPTIONS = [
  {
    key: 'ear',
    i18nKey: 'onboarding.smallestBone.options.ear',
    png: earPNG,
    webp: earWEBP,
  },
  {
    key: 'nose',
    i18nKey: 'onboarding.smallestBone.options.nose',
    png: nosePNG,
    webp: noseWEBP,
  },
  {
    key: 'pinkyToe',
    i18nKey: 'onboarding.smallestBone.options.pinkyToe',
    png: pinkyToePNG,
    webp: pinkyToeWEBP,
  },
  {
    key: 'eye',
    i18nKey: 'onboarding.smallestBone.options.eye',
    png: eyePNG,
    webp: eyeWEBP,
  },
]

const SmallestBoneAnatomyV2 = (props: TPageProps) => (
  <MultipleChoiceQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.smallestBone.title"
    options={OPTIONS}
    correctOptionKey={
      MULTIPLE_CHOICE_CORRECT_ANSWERS[PageId.SMALLEST_BONE_ANATOMY_V2_1]!
    }
    correctExplanationI18nKey="onboarding.smallestBone.correctExplanation"
    incorrectTitleI18nKey="onboarding.smallestBone.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.smallestBone.incorrectExplanation"
    question="Smallest bone in the human body"
  />
)

export default SmallestBoneAnatomyV2
